<template>
  <div class="px-8 py-1">
    <v-container grid-list-xl fluid class="px-0">
      <v-flex xs12 mb-3>
        <h2 class="darkblue--text fs-16 lh-16 font-weight-700">
          DYNAMIC HIERARCHY
        </h2>
        <v-breadcrumbs class="px-0" :items="breadcrumbs"></v-breadcrumbs>
      </v-flex>
      <v-card>
        <v-card-title>
          <v-flex xs9> Group List </v-flex>
          <v-flex xs3 class="text-right">
            <v-icon @click="getData()"> refresh </v-icon>
          </v-flex>
          <v-flex xs4 class="my-5">
            <v-text-field
              id="search"
              v-model="search"
              append-icon="search"
              label="Search by group"
              single-line
              @keyup="searchGroup()"
              hide-details
            ></v-text-field>
          </v-flex>
          <v-flex
            xs8
            class="text-right"
            v-if="hasPermission('create_master_data', 'create')"
          >
            <v-btn
              id="add-brand"
              depressed
              color="secondblue"
              class="white--text"
              @click="create()"
            >
              <v-icon left dark>add</v-icon>
              Add new group
            </v-btn>
          </v-flex>
        </v-card-title>
        <v-data-table
          :headers="headers"
          :items="items"
          :loading="progressDialogLoading"
          :search="search"
          :must-sort="true"
          :options.sync="options"
          :server-items-length="totalItems"
          :sort-desc.sync="descending"
          :footer-props="{
            itemsPerPageOptions: [5, 10, 15, 25]
          }"
        >
          <v-progress-linear
            slot="progress"
            color="primary"
            indeterminate
          ></v-progress-linear>
          <!-- <template v-slot:item.created_by="{ item }">
            {{
              item.logCreate
                ? item.logCreate.length > 0
                  ? item.logCreate[0].user.email
                  : '-'
                : '-'
            }}
          </template>
          <template v-slot:item.updated_by="{ item }">
            {{
              item.logUpdate
                ? item.logUpdate.length > 0
                  ? item.logUpdate[0].user.email
                  : '-'
                : '-'
            }}
          </template> -->
          <template v-slot:item.action="{ item }">
            <!-- <v-btn
              icon
              @click="toDetail(item.id)"
              :id="'btn-detail' + item.id"
              v-if="hasPermission('view_master_data', 'view')"
            >
              <v-icon color="green">remove_red_eye</v-icon>
            </v-btn> -->
            <v-btn
              icon
              :id="'btn-edit' + item.id"
              @click="edit(item.id)"
              v-if="hasPermission('update_master_data', 'update')"
            >
              <v-icon color="secondblue">mdi-square-edit-outline</v-icon>
            </v-btn>
            <v-btn
              :id="'btn-edit' + item.id"
              icon
              v-if="hasPermission('delete_master_data', 'delete')"
              @click="deleteItem(item.id)"
            >
              <v-icon color="red">mdi-delete</v-icon>
            </v-btn>
          </template>
          <template v-slot:no-data>
            <label>No data displayed</label>
          </template>
        </v-data-table>
      </v-card>
    </v-container>
    <v-dialog v-model="showDialog" id="showDialog" persistent max-width="450px">
      <v-card>
        <ValidationObserver ref="obs">
          <v-form @submit.prevent="save" class="pa-0">
            <v-card-title class="primary white--text">
              <span class="pa-0">{{ isCreate ? 'Create' : 'Edit' }} Group</span>
            </v-card-title>
            <v-card-text class="pb-0">
              <v-container>
                <v-row>
                  <v-col cols="12" class="pa-0 pb-0">
                    <ValidationProvider
                      name="Group Name"
                      rules="required"
                      v-slot="{ errors, valid }"
                    >
                      <label>Group Name</label>
                      <v-text-field
                        single-line
                        outlined
                        v-model="group_name"
                        placeholder="Group Name"
                        dense
                        required
                        :error-messages="errors"
                        :success="valid"
                        hide-details
                      ></v-text-field>
                    </ValidationProvider>
                  </v-col>
                  <v-col cols="12" class="pa-0">
                    <ValidationProvider
                      name="Approval Restriction"
                      rules="required"
                    >
                      <v-checkbox
                        v-model="approval_restriction"
                        label="Waiting Approval Restriction"
                        dense
                        class="mt-0"
                        style="margin-left: -5px"
                      ></v-checkbox>
                    </ValidationProvider>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions class="pb-6 px-4">
              <v-spacer></v-spacer>
              <v-btn color="#bd1e19" dark @click="closeDialog()"> Close </v-btn>
              <v-btn color="primary" dark type="submit"> Submit </v-btn>
            </v-card-actions>
          </v-form>
        </ValidationObserver>
      </v-card>
    </v-dialog>
    <progress-dialog :show="progressDialogLoading" text="Please wait">
    </progress-dialog>
  </div>
</template>

<script>
import ProgressDialog from '../../../components/progress_dialog';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import ACLMixin from '../../../mixins/ACLMixin';
import paginationMixin from '../../../mixins/paginationMixin';

export default {
  components: { 'progress-dialog': ProgressDialog },
  mixins: [ACLMixin, paginationMixin],
  data() {
    return {
      progressDialogLoading: true,
      showDialog: false,
      descending: true,
      sort: '',
      totalItems: 0,
      options: {
        itemsPerPage: 5
      },
      search: '',
      isSearch: false,
      breadcrumbs: [
        {
          text: 'Organization Management',
          disabled: true,
          href: 'breadcrumbs_dashboard'
        },
        {
          text: 'Group List',
          disabled: true,
          href: 'breadcrumbs_link_1'
        }
      ],
      page: 1,
      pageCount: 0,
      // itemsPerPage: 10,
      headers: [
        { text: 'Group Name', value: 'name' },
        { text: 'Division', value: 'division.name' },
        {
          text: 'Created At',
          value: 'created_at'
        },
        {
          text: 'Updated At',
          value: 'updated_at'
        },
        {
          text: 'Action',
          value: 'action',
          align: 'center',
          sortable: false
        }
      ],
      items: [],
      group_name: '',
      approval_restriction: false,
      isCreate: false,
      isEdit: false
    };
  },
  watch: {
    descending() {
      this.getData();
    }
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      this.progressDialogLoading = true;
      let { page, itemsPerPage } = this.options;
      if (this.isSearch) {
        page = 1;
      }
      if (this.descending) {
        this.sort = 'desc';
      } else {
        this.sort = 'asc';
      }
      const sort = this.sort;
      // const search = {
      //   name: this.search
      // };
      return this.$store
        .dispatch('dynamic/getAll', {
          page,
          sort,
          limit: itemsPerPage,
          name: this.search
        })
        .then(data => {
          this.progressDialogLoading = false;
          this.isSearch = false;
          if (data.code === 200) {
            this.items = data.data.result;
            this.totalItems = data.data.total_data;
            // this.options = data.data.pagination;
            page = data.data.pagination.current_page;
            itemsPerPage = data.data.pagination.per_page;
            this.options = { page, itemsPerPage };
          } else {
            Swal.fire('Failed!', data.response.data.message.text_en, 'error');
          }
        })
        .catch(err => {
          this.progressDialogLoading = false;
          Swal.fire('Failed!', err.response.data.message.text_en, 'error');
        });
    },
    async save() {
      const validated = await this.$refs.obs.validate();
      if (validated) {
        let text = this.isEdit ? 'edit' : 'create';
        Swal.fire({
          title: '',
          text: `Are you sure want to ${text} this data?`,
          type: 'question',
          showCancelButton: true,
          confirmButtonColor: '#28a0f6',
          cancelButtonColor: '#3085d6',
          confirmButtonText: 'Yes, save it!',
          cancelButtonText: 'Cancel'
        }).then(result => {
          if (result.value) {
            this.progressDialogLoading = true;
            let body = {
              name: this.group_name,
              waiting_approval_restriction: this.approval_restriction
            };
            if (this.isEdit) {
              this.$store
                .dispatch('dynamic/updateGroup', {
                  id: this.id,
                  params: body
                })
                .then(data => {
                  this.progressDialogLoading = false;
                  if (data.code === 200) {
                    Swal.fire('Success!', data.message.text_en, 'success');
                    this.group_name = '';
                    this.approval_restriction = false;
                    this.closeDialog();
                    this.getData();
                  } else {
                    Swal.fire('Failed!', data.data.message.text_en, 'error');
                  }
                })
                .catch(err => {
                  Swal.fire(
                    'Failed!',
                    err.response.data.message.text_en,
                    'error'
                  );
                  this.progressDialogLoading = false;
                });
            } else {
              this.$store
                .dispatch('dynamic/createGroup', body)
                .then(data => {
                  this.progressDialogLoading = false;
                  if (data.code === 200) {
                    Swal.fire('Success!', data.message.text_en, 'success');
                    this.group_name = '';
                    this.closeDialog();
                    this.getData();
                  } else {
                    Swal.fire(
                      'Failed!',
                      data.response.data.message.text_en,
                      'error'
                    );
                  }
                })
                .catch(err => {
                  Swal.fire(
                    'Failed!',
                    err.response.data.message.text_en,
                    'error'
                  );
                  this.progressDialogLoading = false;
                });
            }
          }
        });
      }
    },
    edit(id) {
      this.id = id;
      this.progressDialogLoading = true;
      this.$store
        .dispatch('dynamic/detailGroup', id)
        .then(data => {
          this.showDialog = true;
          this.isEdit = true;
          if (data.code === 200) {
            this.group_name = data.data.name;
            this.approval_restriction = data.data.waiting_approval_restriction;
            this.progressDialogLoading = false;
          } else {
            this.progressDialogLoading = false;
            Swal.fire('Failed!', data.response.data.message.text_en, 'error');
          }
        })
        .catch(err => {
          Swal.fire('Failed!', err.response.data.message.text_en, 'error');
          this.progressDialogLoading = false;
        });
    },
    deleteItem(id) {
      Swal.fire({
        title: 'Are you sure?',
        text: 'You will not be able to recover this group!',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'No, keep it'
      }).then(result => {
        if (result.value) {
          this.progressDialogLoading = true;
          this.$store.dispatch('dynamic/deleteGroup', id).then(data => {
            this.progressDialogLoading = false;
            if (data.code === 200) {
              Swal.fire('Deleted!', data.message.text_en, 'success');
              this.getData();
            } else {
              console.log(data.response);
              Swal.fire('Failed!', data.response.data.message.text_en, 'error');
            }
          });
        }
      });
    },
    create() {
      this.showDialog = true;
      this.isCreate = true;
    },
    clear() {
      requestAnimationFrame(() => {
        this.$refs.obs.reset();
      });
    },
    closeDialog() {
      this.showDialog = false;
      this.isCreate = false;
      this.isEdit = false;
      this.group_name = '';
      this.clear();
    },
    searchGroup() {
      this.isSearch = true;
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.getData();
      }, 900);
    },
    toDetail(val) {
      this.$router.push({
        name: 'dynamic-hierarchy-detail',
        params: { id: val }
      });
    }
  }
};
</script>
